export type ChangelogItemType = 'new' | 'improved' | 'fixed';

export interface ChangelogItem {
  type: ChangelogItemType;
  it: string;
  en: string;
}

export interface ChangelogEntry {
  /** What a reader has seen is remembered by this; the order of the list, not of the ids, is the order of the releases. */
  id: string;
  /** `YYYY-MM-DD`. */
  date: string;
  items: ChangelogItem[];
}

/**
 * What changed, for the people who use the back-office. Newest first, written
 * by hand: commit messages say what a developer did, this says what an
 * operator can now do. Every pull request that changes something they can see
 * adds its line here, in both languages.
 *
 * It ships inside the bundle, so it is readable by anyone who can open the
 * app (the button is back-office only, the text is not secret): no internal
 * detail, nothing that is not already on screen. Never empty.
 */
export const CHANGELOG: ChangelogEntry[] = [
  {
    id: '2026-11-03',
    date: '2026-11-03',
    items: [
      {
        type: 'improved',
        it: 'Nuova grafica: i colori, i caratteri e i componenti di ScaleBrain sono ora quelli del brand (navy e ambra, sfondo caldo), in chiaro e in scuro.',
        en: 'New look: ScaleBrain colours, fonts and components now follow the brand (navy and amber, warm background), in light and dark.',
      },
    ],
  },
  {
    id: '2026-11-02',
    date: '2026-11-02',
    items: [
      {
        type: 'new',
        it: 'Profilo azienda: oltre alla startup (stage, TRL), un\'azienda si descrive con fatturato, numero di sedi e funzioni coinvolte nell\'assessment. Il tipo si sceglie nel profilo del workspace.',
        en: 'Company profile: besides the startup one (stage, TRL), a company is described by revenue, number of sites and the functions involved in the assessment. The type is chosen in the workspace profile.',
      },
    ],
  },
  {
    id: '2026-10-29-2',
    date: '2026-10-29',
    items: [
      {
        type: 'new',
        it: 'Annunci: un admin può mostrare a tutti una barra in cima all\'app, con messaggio, colore e scadenza (Amministrazione → Annunci).',
        en: 'Announcements: an admin can show everyone a bar at the top of the app, with a message, a colour and an expiry (Administration → Announcements).',
      },
    ],
  },
  {
    id: '2026-10-29',
    date: '2026-10-29',
    items: [
      {
        type: 'new',
        it: 'La versione dell\'app compare in piccolo in fondo alla pagina. Se non coincide con quella del server, un avviso ti invita a ricaricare.',
        en: 'The app version now shows in small type at the bottom of the page. If it does not match the server\'s, a notice asks you to reload.',
      },
      {
        type: 'new',
        it: 'Questo pannello: qui trovi le novità di ogni rilascio.',
        en: 'This panel: here you find what is new in each release.',
      },
      {
        type: 'new',
        it: 'L\'agente AI può proporre modifiche al profilo di un\'azienda; le accetti o le rifiuti tu dalla scheda Profilo.',
        en: 'The AI agent can propose changes to a company\'s profile; you accept or reject them from the Profile tab.',
      },
    ],
  },
  {
    id: '2026-10-27',
    date: '2026-10-27',
    items: [
      {
        type: 'new',
        it: 'Onboarding di nuove aziende: apri una sessione con un codice d\'invito, le aziende si candidano e tu accetti o rifiuti.',
        en: 'Onboarding for new companies: open a session with an invite code, companies apply and you accept or reject.',
      },
      {
        type: 'new',
        it: 'I report si scaricano in PDF con il brand ScaleBrain.',
        en: 'Reports can be downloaded as a PDF with the ScaleBrain brand.',
      },
    ],
  },
];
